<template>
  <div ref="container" class="model-container" :style="containerStyle">
    <slot v-if="useSlot"></slot>
    <img 
      v-else
      :src="fallbackImageUrl" 
      alt="3D Model Fallback" 
      class="fallback-image"
      @click="$emit('click', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'FallbackModelViewer',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: '3D Model'
    },
    fallbackImageUrl: {
      type: String,
      default: 'https://pub-083487639dd44281913f58e8e6638018.r2.dev/human_diagram.png'
    },
    useSlot: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    containerStyle() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  mounted() {
    // Emit load event once mounted
    this.$nextTick(() => {
      this.$emit('load');
    });
  },
  methods: {
    // Provide dummy methods that would be present on model-viewer
    activateAR() {
      console.warn('AR not available in fallback mode');
    },
    jumpCameraToGoal() {
      console.warn('Camera controls not available in fallback mode');
    },
    resetTurntable() {
      console.warn('Turntable controls not available in fallback mode');
    }
  }
};
</script>

<style scoped>
.model-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.05);
  overflow: hidden;
  position: relative;
}

.fallback-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.fallback-image:hover {
  transform: scale(1.02);
}
</style>